// Copyright © 2024 Broadcom Inc. and its subsidiaries. All Rights Reserved.
import { isString } from 'lodash';

export const getParsedApiDetails = (apiDetails) => ({
  ...apiDetails,
  authenticationParameters: isString(apiDetails.authenticationParameters) ?
    JSON.parse(apiDetails.authenticationParameters) : apiDetails.authenticationParameters,
});

export const getParsedSwaggerContent = (data) => {
  let parseJSON = {};
  if(data && data.content) {
    parseJSON = isString(data.content) ? JSON.parse(data.content) : data.content;
  }
  return parseJSON;
}

export default () => {};
